import { Injectable } from '@angular/core';

type JQueryLikeElement = {
  addClass: (className: string) => void;
  remove: (selector: string) => void;
};

declare const $:
  | ((selector: string) => JQueryLikeElement)
  | undefined;

@Injectable({
  providedIn: 'root',
})
export class PageService {
  onInitPage() {
    this.closeMenuSidebar();
    window.scrollTo(0, 0);
  }
  closeMenuSidebar() {
    if (!$) return;
    $('.sidebar').addClass('cerrar');
    $('.menu-opened').remove('menu-opened');
  }
}
